export const useEnhanceProductCardsHtmlForBlogDetails = () => {
    
  function enhanceProductCardsHtml(html) {
    const raw = String(html || "");
    if (!raw) return "";
    if (typeof document === "undefined") return raw;
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(raw, "text/html");

      const iconClock =
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 8v5l3 2" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round"/><path d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" stroke="#9CA3AF" strokeWidth="2"/></svg>';
      const iconCar =
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M3 11h18l-1.2 5a2 2 0 0 1-2 1.6H6.2a2 2 0 0 1-2-1.6L3 11Z" stroke="#9CA3AF" strokeWidth="2" strokeLinejoin="round"/><path d="M5 11V8h3l2-2h4l2 2h3v3" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round"/><path d="M7.5 17.5h0" stroke="#9CA3AF" strokeWidth="3" strokeLinecap="round"/><path d="M16.5 17.5h0" stroke="#9CA3AF" strokeWidth="3" strokeLinecap="round"/></svg>';
      const iconMoney =
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 7h16v10H4V7Z" stroke="#9CA3AF" strokeWidth="2"/><path d="M8 12c0 1.657 1.79 3 4 3s4-1.343 4-3-1.79-3-4-3-4 1.343-4 3Z" stroke="#9CA3AF" strokeWidth="2"/><path d="M12 7v-2" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round"/><path d="M12 19v-2" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round"/></svg>';

      const cards = Array.from(doc.querySelectorAll(".ta-product-card"));

      const isSpacingNode = (el) => {
        if (!el) return false;
        const tag = String(el.tagName || "").toLowerCase();
        if (tag === "br") return true;
        // Allow common editor wrapper tags that can be "visually blank".
        const blankableTags = new Set([
          "p",
          "div",
          "span",
          "strong",
          "b",
          "em",
          "i",
          "u",
          "s",
          "small",
          "mark",
          "a",
        ]);
        if (!blankableTags.has(tag)) return false;

        const txt = String(el.textContent || "")
          .replace(/\u00A0/g, " ")
          .trim();
        if (txt) return false;

        // Some editors wrap blank lines like: <div><p><br></p></div>
        // Treat any node whose descendants are ONLY <br> or empty p/div/span as spacing.
        const isBlankTree = (node, depth) => {
          if (!node || depth > 6) return true;
          const t = String(node.tagName || "").toLowerCase();
          if (t === "br") return true;
          if (!blankableTags.has(t)) return false;
          const ttxt = String(node.textContent || "")
            .replace(/\u00A0/g, " ")
            .trim();
          if (ttxt) return false;
          const children = node.children ? Array.from(node.children) : [];
          if (!children.length) return true;
          return children.every((c) => isBlankTree(c, depth + 1));
        };

        if (isBlankTree(el, 0)) return true;

        // Fallback string checks for common cases.
        const inner = String(el.innerHTML || "")
          .toLowerCase()
          .replace(/\s+/g, "")
          .replace(/&nbsp;/g, "")
          .replace(/&#160;/g, "");
        return (
          inner === "" ||
          inner === "<br>" ||
          inner === "<br/>" ||
          inner === "<br><br>" ||
          inner === "<br/><br/>"
        );
      };

      const removeTrailingSpacingNodes = (afterEl) => {
        if (!afterEl) return;
        let n = afterEl.nextElementSibling;
        // Remove a few consecutive empty blocks (avoid touching real content).
        let guard = 0;
        while (n && guard < 10) {
          guard += 1;
          if (!isSpacingNode(n)) break;
          const toRemove = n;
          n = n.nextElementSibling;
          toRemove.remove();
        }
      };

      const tightenNextContentSpacing = (afterEl) => {
        if (!afterEl) return;
        // 1) Remove the obvious blank nodes right after.
        removeTrailingSpacingNodes(afterEl);

        // 2) Find the next real sibling.
        let next = afterEl.nextElementSibling;
        if (!next) return;

        const applyTightTop = (el) => {
          if (!el || !el.style) return;
          el.style.marginTop = "0";
          // Headings on this page use big padding; reduce only top padding to avoid a large gap.
          const tag = String(el.tagName || "").toLowerCase();
          if (/^h[1-6]$/.test(tag)) {
            el.style.paddingTop = "6px";
          }
        };

        // If next is a wrapper, adjust its first child too.
        applyTightTop(next);
        const fc = next.firstElementChild;
        if (fc) applyTightTop(fc);
      };

      for (const card of cards) {
        const looksLikeDuration = (t) =>
          /\b(min|mins|minute|minutes|hour|hours|day|days)\b/i.test(t);
        const hasSvg = (el) => Boolean(el.querySelector("svg"));
        const rowVisibleText = (rowEl) => {
          try {
            const clone = rowEl.cloneNode(true);
            const svgs = clone.querySelectorAll
              ? clone.querySelectorAll("svg")
              : [];
            for (const s of Array.from(svgs)) s.remove();
            return String(clone.textContent || "")
              .replace(/\s+/g, " ")
              .trim();
          } catch {
            return String(rowEl?.textContent || "")
              .replace(/\s+/g, " ")
              .trim();
          }
        };

        const infoStack =
          card.querySelector(
            'div[style*="flex-direction:column"][style*="gap:10px"]',
          ) ||
          card.querySelector(
            'div[style*="flex-direction:column"][style*="gap: 10px"]',
          );

        const rows = infoStack
          ? Array.from(infoStack.children).filter(
              (el) =>
                el &&
                el.tagName &&
                el.tagName.toLowerCase() === "div" &&
                String(el.style?.display || "") === "flex" &&
                String(el.style?.alignItems || "") === "center",
            )
          : [];

        const tryInjectIconIntoRow = (rowEl, svgMarkup, matcher) => {
          if (!rowEl) return false;
          const txt = rowVisibleText(rowEl);
          if (!txt) return false;
          const ok =
            matcher instanceof RegExp
              ? matcher.test(txt)
              : String(txt).includes(String(matcher || ""));
          if (!ok) return false;
          if (hasSvg(rowEl)) return false;
          const wrap = doc.createElement("span");
          wrap.innerHTML = svgMarkup;
          if (wrap.firstElementChild)
            rowEl.insertBefore(wrap.firstElementChild, rowEl.firstChild);
          return true;
        };

        for (const r of rows) {
          const txt = rowVisibleText(r);
          if (!txt) continue;
          if (hasSvg(r)) continue;

          let svg = "";
          if (looksLikeDuration(txt)) svg = iconClock;
          else if (
            /private\s*&\s*shared/i.test(txt) ||
            /\bprivate\b/i.test(txt)
          )
            svg = iconCar;
          else if (/reserve\s*now/i.test(txt) || /pay\s*later/i.test(txt))
            svg = iconMoney;
          if (!svg) continue;

          const wrap = doc.createElement("span");
          wrap.innerHTML = svg;
          if (wrap.firstElementChild)
            r.insertBefore(wrap.firstElementChild, r.firstChild);
        }

        // Some editor variants don't match the exact `infoStack` structure; still ensure "Private & Shared" gets the car icon.
        // Look for any flex+center row within card and inject if missing.
        try {
          const anyRows = Array.from(
            card.querySelectorAll(
              'div[style*="display:flex"][style*="align-items:center"]',
            ),
          );
          for (const r of anyRows) {
            // Match "Private & Shared" (or any private indicator).
            if (tryInjectIconIntoRow(r, iconCar, /private\s*&\s*shared/i))
              continue;
            tryInjectIconIntoRow(r, iconCar, /\bprivate\b/i);
          }
        } catch {
          // ignore
        }

        // Fallback: "Private & Shared" is sometimes just plain text inside a leaf node (no flex styles).
        // In that case, convert that node into an icon+text row. Also handle duration + reserve/pay-later lines.
        try {
          const findInfoScope = () => {
            if (infoStack) return infoStack;
            // Try to locate the small "info lines" area by finding a leaf that contains any of the known phrases.
            const hint = Array.from(
              card.querySelectorAll("div, p, span, li"),
            ).find((el) => {
              if (!el) return false;
              const txt = String(el.textContent || "")
                .replace(/\s+/g, " ")
                .trim();
              if (!txt) return false;
              return (
                looksLikeDuration(txt) ||
                /private\s*&\s*shared/i.test(txt) ||
                /\bprivate\b/i.test(txt) ||
                /reserve\s*now/i.test(txt) ||
                /pay\s*later/i.test(txt)
              );
            });
            return hint?.parentElement || hint || card;
          };

          const scopeRoot = findInfoScope();

          const isLeafLineCandidate = (el) => {
            if (!el) return false;
            if (hasSvg(el)) return false;
            // Don't touch buttons/links/badges.
            try {
              if (typeof el.closest === "function") {
                if (el.closest("button,a")) return false;
                // Never touch headings / title area.
                if (el.closest("h1,h2,h3,h4,h5,h6")) return false;
                // Common title styles in the editor card (avoid injecting into the heading row).
                if (
                  el.closest('div[style*="font-size:20px"]') ||
                  el.closest('div[style*="font-size: 20px"]') ||
                  el.closest('div[style*="font-size:18px"]') ||
                  el.closest('div[style*="font-size: 18px"]')
                ) {
                  return false;
                }
              }
            } catch {
              // ignore
            }
            // Skip big wrappers: we only want leaf-ish nodes that likely represent a single line.
            const childEls = el.children ? Array.from(el.children) : [];
            const meaningfulChildren = childEls.filter(
              (c) => c && String(c.tagName || "").toLowerCase() !== "br",
            );
            if (meaningfulChildren.length > 0) return false;
            const txt = String(el.textContent || "")
              .replace(/\s+/g, " ")
              .trim();
            if (!txt) return false;
            // Avoid converting long paragraphs.
            if (txt.length > 80) return false;
            return true;
          };

          const candidates = Array.from(
            scopeRoot.querySelectorAll("div, p, span, li"),
          ).filter(isLeafLineCandidate);

          const convertLeafToIconRow = (el, svgMarkup, txt) => {
            if (!el || !txt) return false;
            if (hasSvg(el)) return false;
            el.textContent = "";
            el.style.display = "flex";
            el.style.alignItems = "center";
            el.style.gap = "10px";
            el.style.color = el.style.color || "#6B7280";
            el.style.fontSize = el.style.fontSize || "13px";
            el.style.lineHeight = el.style.lineHeight || "1.25";
            el.style.minWidth = el.style.minWidth || "0";

            const wrap = doc.createElement("span");
            wrap.innerHTML = svgMarkup;
            const label = doc.createElement("span");
            label.style.minWidth = "0";
            label.style.overflow = "hidden";
            label.style.textOverflow = "ellipsis";
            label.style.whiteSpace = "nowrap";
            label.textContent = txt;

            if (wrap.firstElementChild) el.appendChild(wrap.firstElementChild);
            el.appendChild(label);
            return true;
          };

          for (const el of candidates) {
            const txt = String(el.textContent || "")
              .replace(/\s+/g, " ")
              .trim();
            if (!txt) continue;

            // 1) Duration line: "30 mins", "2 hours", etc.
            if (looksLikeDuration(txt)) {
              convertLeafToIconRow(el, iconClock, txt);
              continue;
            }
            // 2) Private/shared line.
            if (/private\s*&\s*shared/i.test(txt) || /\bprivate\b/i.test(txt)) {
              convertLeafToIconRow(el, iconCar, txt);
              continue;
            }
            // 3) Reserve / pay later line.
            if (/reserve\s*now/i.test(txt) || /pay\s*later/i.test(txt)) {
              convertLeafToIconRow(el, iconMoney, txt);
              continue;
            }
          }
        } catch {
          // ignore
        }

        // Ensure “Reserve Now - Pay Later” row exists INSIDE the info stack (not below the card).
        if (infoStack) {
          const hasReserve = /reserve\s*now/i.test(
            String(infoStack.textContent || ""),
          );
          if (!hasReserve) {
            const row = doc.createElement("div");
            row.style.display = "flex";
            row.style.alignItems = "center";
            row.style.gap = "10px";
            row.style.color = "#6B7280";
            row.style.fontSize = "13px";
            row.style.lineHeight = "1.25";
            row.style.minWidth = "0";
            row.innerHTML = `${iconMoney}<span class="min-w-0 overflow-hidden text-ellipsis whitespace-nowrap">Reserve Now - Pay Later</span>`;
            infoStack.appendChild(row);
          }
        }

        // Add class hooks for responsive CSS (footer/buttons).
        // Match any `border-top: … solid` (editors often add spaces: `border-top: 1px solid`).
        try {
          const footer = Array.from(card.querySelectorAll("div")).find((d) => {
            if (!d || typeof d.getAttribute !== "function") return false;
            const st = String(d.getAttribute("style") || "");
            if (!/border-top\s*:/i.test(st) || !/solid/i.test(st)) return false;
            return Boolean(
              d.querySelector(".ta-product-card-btn-primary") ||
              d.querySelector(".ta-product-card-btn-secondary"),
            );
          });
          if (footer) footer.classList.add("ta-product-card-footer");
        } catch {
          // ignore issue and solve to show error in frontend
        }

        // Editor sometimes adds empty nodes after the card -> huge white gap. Remove/tighten them.
        tightenNextContentSpacing(card);
      }

      // Same issue after tables: remove the empty spacing paragraphs right after each table.
      try {
        const tables = Array.from(doc.querySelectorAll("table"));
        const looksLikeTableWrapper = (el) => {
          if (!el || !el.tagName) return false;
          const tag = String(el.tagName || "").toLowerCase();
          if (tag === "figure") return true;
          const cls = String(el.className || "").toLowerCase();
          if (cls.includes("table-responsive")) return true;
          if (cls.split(/\s+/).includes("table")) return true;
          return false;
        };

        for (const t of tables) {
          // 1) Fix spacing nodes right after the table.
          tightenNextContentSpacing(t);

          // 2) Many CMS editors wrap tables inside figure/div; the *wrapper* is what has the next sibling
          // (empty paragraphs/br blocks), so also tighten after wrapper.
          const p = t.parentElement;
          if (looksLikeTableWrapper(p)) {
            tightenNextContentSpacing(p);
          }
        }
      } catch {
        // ignore
      }

      return doc.body.innerHTML;
    } catch {
      return raw;
    }
  }

  return {enhanceProductCardsHtml};
};
